import type { RouteRecordRaw, Router } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import('@/pages/sign-in/index.vue'),
  },
  {
    path: '/',
    component: () => import('@/layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/pages/dashboard/index.vue'),
      },
      {
        path: 'clients',
        name: 'clients',
        component: () => import('@/pages/clients/index.vue'),
      },
      {
        path: 'clients/new',
        name: 'client-new',
        component: () => import('@/pages/clients/new.vue'),
      },
      {
        path: 'clients/:id',
        name: 'client-detail',
        component: () => import('@/pages/clients/[id].vue'),
      },
      {
        path: 'clients/:id/edit',
        name: 'client-edit',
        component: () => import('@/pages/clients/[id]/edit.vue'),
      },
      {
        path: 'clients/:id/people/new',
        name: 'client-people-new',
        component: () => import('@/pages/clients/[id]/people/new.vue'),
      },
      {
        path: 'clients/:id/people/:personId/edit',
        name: 'client-people-edit',
        component: () => import('@/pages/clients/[id]/people/[personId]/edit.vue'),
      },
      {
        path: 'regulatory-functions',
        name: 'regulatory-functions',
        component: () => import('@/pages/regulatory-functions/index.vue'),
      },
      {
        path: 'regulatory-functions/new',
        name: 'regulatory-function-new',
        component: () => import('@/pages/regulatory-functions/new.vue'),
      },
      {
        path: 'regulatory-functions/:id/edit',
        name: 'regulatory-function-edit',
        component: () => import('@/pages/regulatory-functions/[id]/edit.vue'),
      },
    ],
  },
]

function waitForClerk(): Promise<typeof window.Clerk> {
  return new Promise((resolve) => {
    const check = () => {
      if (window.Clerk?.loaded) {
        resolve(window.Clerk)
      } else {
        setTimeout(check, 50)
      }
    }
    check()
  })
}

export function setupAuthGuard(router: Router) {
  router.beforeEach(async (to) => {
    const clerk = await waitForClerk()

    const isSignedIn = !!clerk?.user
    const isPublicRoute = to.name === 'sign-in'

    if (!isSignedIn && !isPublicRoute) {
      return { name: 'sign-in' }
    }

    if (isSignedIn && isPublicRoute) {
      return { name: 'dashboard' }
    }
  })
}
